'use client';

import * as RadixForm from '@radix-ui/react-form';
import { PhoneNumberInput } from '@tuic/web-compositions/core/PhoneNumberInput';
import {
  InputFieldError,
  InputFieldLabel,
  InputFieldNote,
} from '@tuic/web-compositions/shared/InputField';

import type { AnyFieldApi } from '@tanstack/react-form';
import type { FC, ReactNode } from 'react';

export type ManifestPhoneFieldProps = {
  field: AnyFieldApi;
  label?: ReactNode;
  note?: ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  defaultCountryCode?: string;
};

export const ManifestPhoneField: FC<ManifestPhoneFieldProps> = ({
  field,
  label,
  note,
  required,
  disabled,
  className,
  defaultCountryCode,
}) => {
  const value = (field.state.value ?? '') as string;
  const error = field.state.meta.errors.map(e => e?.message).join(',');

  return (
    <RadixForm.Field name={field.name} className={className} asChild>
      <div className="space-y-1">
        {label && (
          <RadixForm.Label asChild>
            <InputFieldLabel asChild>
              <div>
                {label}
                {required ? '*' : ''}
              </div>
            </InputFieldLabel>
          </RadixForm.Label>
        )}
        <PhoneNumberInput
          name={field.name}
          value={value}
          defaultCountryCode={defaultCountryCode}
          disabled={disabled}
          onValueChange={({ dialCode, localNumber }) =>
            field.handleChange(
              localNumber ? `${dialCode} ${localNumber}`.trim() : '',
            )
          }
        />
        {error ? (
          <InputFieldError>{error}</InputFieldError>
        ) : (
          note && <InputFieldNote>{note}</InputFieldNote>
        )}
      </div>
    </RadixForm.Field>
  );
};
